export function initPWA(): void {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/sw.js', { scope: '/' })
        .then((registration) => {
          if (import.meta.env.DEV) {
            console.info('SW registered:', registration.scope);
          }
        })
        .catch((error) => {
          console.warn('SW registration failed:', error.message);
        });
    });
  }
}
